/*
  Ulevi custom behaviour — loaded site-wide from layout/theme.liquid.

  Two helpers, both defensive:

  1. Direct add-to-cart for hand-built sections (forms carrying .ulh-atc and a
     data-payload attribute). Falls back to a normal form POST on any failure,
     so the buy path can never be worse than plain HTML.

  2. Repair of blank product-card button labels. products.product.add_to_cart
     and products.product.choose_options are empty strings in locales/ka.json,
     so Dawn renders buttons with no text. This fills only genuinely empty
     labels — once ka.json is corrected it finds nothing to do and stops
     mattering. On the English storefront it also replaces Georgian labels,
     because the en translation layer currently serves Georgian for these keys.
*/
(function () {
  'use strict';

  var IS_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var LABELS = IS_EN
    ? { add: 'Add to cart', options: 'Choose options' }
    : { add: 'კალათაში დამატება', options: 'ვარიანტები' };
  var GEORGIAN = /[Ⴀ-ჿ]/;

  /* ---------- 1. Direct add-to-cart ---------- */

  function restore(btn, html) {
    btn.innerHTML = html;
    btn.disabled = false;
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.classList || !form.classList.contains('ulh-atc')) return;
    var payload = form.getAttribute('data-payload');
    var body;
    if (payload) {
      try { body = JSON.parse(payload); } catch (e) { return; }
    } else {
      /* No payload: read the variant from a select/hidden input named id. */
      var idEl = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      if (!idEl || !idEl.value) return;
      body = { items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] };
    }

    ev.preventDefault();
    var btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '…';

    var drawer = document.querySelector('cart-drawer');
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (res) {
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(res); restore(btn, original); return; } catch (e) {}
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        restore(btn, original);
        HTMLFormElement.prototype.submit.call(form);
      });
  }, false);

  /* ---------- 2. Blank button labels ---------- */

  function fixLabels() {
    var buttons = document.querySelectorAll('.quick-add__submit');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.getAttribute('data-ul-labelled') === '1') continue;

      var text = btn.hasAttribute('data-sold-out-message') ? LABELS.add : LABELS.options;
      /* The label span is the one that is NOT the hidden sold-out message. */
      var span = btn.querySelector('span:not(.sold-out-message)');

      if (span) {
        var cur = span.textContent.trim();
        if (cur !== '' && !(IS_EN && GEORGIAN.test(cur))) continue;
        span.textContent = text;
      } else {
        /* Dawn emits the "choose options" label as a bare text node with no
           span, so there is nothing to fill — insert one before the spinner. */
        var direct = '';
        for (var n = 0; n < btn.childNodes.length; n++) {
          if (btn.childNodes[n].nodeType === 3) direct += btn.childNodes[n].nodeValue;
        }
        var curDirect = direct.trim();
        if (curDirect !== '' && !(IS_EN && GEORGIAN.test(curDirect))) continue;
        if (curDirect !== '') {
          for (var d = btn.childNodes.length - 1; d >= 0; d--) {
            if (btn.childNodes[d].nodeType === 3) btn.removeChild(btn.childNodes[d]);
          }
        }
        var el = document.createElement('span');
        el.textContent = text;
        btn.insertBefore(el, btn.firstChild);
      }
      btn.setAttribute('data-ul-labelled', '1');
    }
  }

  function run() { try { fixLabels(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Cards are re-rendered by filtering, pagination and the cart drawer, so
     watch for new ones — throttled to one pass per frame. */
  if (window.MutationObserver) {
    var queued = false;
    try {
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; run(); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
})();

/* ---------- 3. Scroll reveal + header shadow ----------
   Elements listed in SELECTOR fade and slide up as they enter the viewport.
   Siblings arriving in the same frame are staggered. An inline guard in
   layout/theme.liquid adds html.u-anim before first paint (so nothing
   flashes) and removes it again after 3s if this script never ran, so a
   blocked script can only ever mean "no animation", never hidden content. */
(function () {
  'use strict';

  var root = document.documentElement;
  /* Must match the :where() list in ulevi-custom.css. */
  var SELECTOR = '.grid__item,.card-wrapper,.ulh__copy>*,.ulh__visual,.ulc-head,.ulc-card,.ulc-bundle,.title-wrapper,.title-wrapper-with-link,.collection-hero,.rich-text__blocks,.ulw-head,.ulw-card,.ulw-bundle,.ulw-all,.ulx';

  function bail() {
    root.classList.remove('u-anim');
  }

  if (!('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      (window.Shopify && window.Shopify.designMode)) {
    bail();
    return;
  }

  window.__uReveal = true;
  root.classList.add('u-anim');

  var pending = [];
  var flushQueued = false;

  function flush() {
    flushQueued = false;
    var batch = pending;
    pending = [];
    /* Order by position on screen so the stagger reads top-left to bottom-right. */
    batch.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (ra.top - rb.top) || (ra.left - rb.left);
    });
    for (var i = 0; i < batch.length; i++) {
      batch[i].style.setProperty('--u-delay', Math.min(i, 10) * 70 + 'ms');
      batch[i].classList.add('u-in');
    }
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      pending.push(entries[i].target);
      io.unobserve(entries[i].target);
    }
    if (pending.length && !flushQueued) {
      flushQueued = true;
      requestAnimationFrame(flush);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function tag() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-u-reveal') === '1') continue;
      /* Nested inside something that already reveals: show it at once and
         let the parent carry the motion. */
      if (el.parentNode && el.parentNode.closest && el.parentNode.closest('.u-reveal')) {
        el.setAttribute('data-u-reveal', '1');
        el.classList.add('u-in');
        continue;
      }
      el.setAttribute('data-u-reveal', '1');
      el.classList.add('u-reveal');
      io.observe(el);
    }
  }

  function start() {
    try { tag(); } catch (e) { bail(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Elements added later (filters, pagination, quick-add) are tagged too, but
     anything already inside the viewport at that moment reveals at once. */
  if (window.MutationObserver) {
    var q = false;
    try {
      new MutationObserver(function () {
        if (q) return;
        q = true;
        requestAnimationFrame(function () { q = false; try { tag(); } catch (e) {} });
      }).observe(document.body || root, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* Header shadow once scrolled. */
  var header = document.querySelector('.shopify-section-header');
  if (header) {
    var scrolled = false;
    var onScroll = function () {
      var s = window.scrollY > 8;
      if (s !== scrolled) {
        scrolled = s;
        header.classList.toggle('u-scrolled', s);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/* ---------- 4. Variant picker for hand-built sections ----------
   <select name="id" class="ulv-select"> inside [data-ulv]: swaps the card
   image and the price on the button when the scent changes. */
(function () {
  'use strict';
  document.addEventListener('change', function (ev) {
    var sel = ev.target;
    if (!sel || !sel.classList || !sel.classList.contains('ulv-select')) return;
    var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
    var box = sel.closest('[data-ulv]');
    if (!opt || !box) return;
    var img = box.querySelector('img[data-ulv-img]');
    var src = opt.getAttribute('data-img');
    if (img && src) { img.removeAttribute('srcset'); img.src = src; }
    var btn = box.querySelector('[data-ulv-btn]');
    var price = opt.getAttribute('data-price');
    if (btn && price) btn.textContent = (btn.getAttribute('data-label') || '') + ' — ' + price;
  });
})();

/* ---------- 5. Scent chips for the Luxury Caffè banner ----------
   Progressive enhancement: turns the <select class="ulv-select"> inside .ulx
   into a row of chip buttons. Clicking a chip sets the select value and
   fires the same change event part 4 listens to, so image + price update
   exactly as before and the add-to-cart form still posts the select's id.
   Styles live in ulevi-custom.css, section 10. */
(function () {
  'use strict';

  function build(sel) {
    if (sel.getAttribute('data-chips') === '1') return;
    var form = sel.closest('form');
    var wrap = sel.closest('.ulw-select');
    if (!form || !wrap) return;

    var label = document.createElement('span');
    label.className = 'ulx__chips-label';
    label.textContent = sel.getAttribute('aria-label') || '';

    var row = document.createElement('div');
    row.className = 'ulx__chips';
    row.setAttribute('role', 'radiogroup');
    if (label.textContent) row.setAttribute('aria-label', label.textContent);

    var chips = [];
    for (var i = 0; i < sel.options.length; i++) {
      (function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ulx__chip';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-value', opt.value);
        /* Option text carries " — sold out" for unavailable scents; the chip
           shows the bare name and marks itself instead. */
        b.textContent = opt.text.replace(/\s+[—-]\s+.*$/, '');
        if (opt.disabled) {
          b.disabled = true;
          b.classList.add('is-soldout');
          b.setAttribute('aria-disabled', 'true');
        }
        b.addEventListener('click', function () {
          if (opt.disabled) return;
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
        chips.push(b);
        row.appendChild(b);
      })(sel.options[i]);
    }

    function sync() {
      for (var j = 0; j < chips.length; j++) {
        var on = chips[j].getAttribute('data-value') === sel.value;
        chips[j].classList.toggle('is-on', on);
        chips[j].setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }

    sync();
    wrap.parentNode.insertBefore(label, wrap);
    wrap.parentNode.insertBefore(row, wrap);
    form.classList.add('has-chips');
    sel.setAttribute('data-chips', '1');
  }

  function run() {
    try {
      var sels = document.querySelectorAll('.ulx select.ulv-select');
      for (var i = 0; i < sels.length; i++) build(sels[i]);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ---------- 6. Mini cart: "shopping list" popup ----------
   Replaces Dawn's side drawer with a centred popup rendered straight from
   /cart.js, so what you see is always the real cart: every open re-fetches,
   quantity +/- and remove go through /cart/change.js and re-render from the
   response. Dawn's own cart-drawer element stays in the DOM (product forms
   and quick-add call its renderContents/open), but both now route here.
   Contents: free-delivery progress (99 GEL), one-tap "add a car freshener"
   nudge while under the threshold, line items, subtotal, checkout. */
(function () {
  'use strict';

  var THRESHOLD = 9900; /* tetri */
  var NUDGE_VARIANT = 47547894563114; /* Fresh Passion "Lips" car freshener, 14.90 */
  var IS_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var T = IS_EN ? {
    title: 'Shopping list',
    items: function (n) { return n === 1 ? '1 item' : n + ' items'; },
    empty: 'Your list is empty',
    emptySub: 'Fresh, clean, Italian — pick something for home.',
    shop: 'Start shopping',
    subtotal: 'Subtotal',
    tax: 'Delivery is calculated at checkout',
    checkout: 'Checkout',
    cont: 'Continue shopping',
    remove: 'Remove',
    discount: '🎁 Discount',
    freeDone: '🎉 <b>Free delivery unlocked</b> — anywhere in Georgia',
    freeLeft: function (x) { return '🚚 Add <b>' + x + '</b> more for free delivery'; },
    nudge: '🚗 Add a car freshener — 14.90 ₾',
    close: 'Close'
  } : {
    title: 'საყიდლების სია',
    items: function (n) { return n + ' ნივთი'; },
    empty: 'სია ჯერ ცარიელია',
    emptySub: 'სუფთა, სურნელოვანი, იტალიური — აირჩიე რამე სახლისთვის.',
    shop: 'შოპინგის დაწყება',
    subtotal: 'სუბტოტალი',
    tax: 'მიტანის ღირებულება ითვლება გადახდისას',
    checkout: 'შეკვეთის გაფორმება',
    cont: 'შოპინგის გაგრძელება',
    remove: 'წაშლა',
    discount: '🎁 ფასდაკლება',
    freeDone: '🎉 <b>მიტანა უფასოა</b> — მთელ საქართველოში',
    freeLeft: function (x) { return '🚚 დაამატე კიდევ <b>' + x + '</b> და მიტანა უფასო იქნება'; },
    nudge: '🚗 დაამატე მანქანის სურნელი — 14.90 ₾',
    close: 'დახურვა'
  };

  var modal, busy = false, lastFocus = null;

  function money(tetri) { return (tetri / 100).toFixed(2) + ' ₾'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---- shell ---- */
  function build() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'ulm';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', T.title);
    modal.hidden = true;
    modal.innerHTML =
      '<div class="ulm__overlay" data-ulm-close></div>' +
      '<div class="ulm__card" tabindex="-1">' +
        '<span class="ulm__tape" aria-hidden="true"></span>' +
        '<button type="button" class="ulm__close" data-ulm-close aria-label="' + esc(T.close) + '">&times;</button>' +
        '<div class="ulm__head"><h2 class="ulm__title">🧺 ' + esc(T.title) + '</h2><span class="ulm__count"></span></div>' +
        '<div class="ulm__ship"><p class="ulm__ship-text"></p><div class="ulm__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><i></i></div><button type="button" class="ulm__nudge" data-ulm-nudge hidden style="display:none">' + esc(T.nudge) + '</button></div>' +
        '<div class="ulm__list"></div>' +
        '<div class="ulm__foot">' +
          '<div class="ulm__sub ulm__disc" style="display:none"><span>' + esc(T.discount) + '</span><b class="ulm__disc-val" style="color:#2b5e4b;font-size:1.5rem"></b></div>' +
          '<div class="ulm__sub"><span>' + esc(T.subtotal) + '</span><b class="ulm__total"></b></div>' +
          '<p class="ulm__tax">' + esc(T.tax) + '</p>' +
          '<a class="ulm__checkout" href="' + ROOT + 'checkout">' + esc(T.checkout) + ' <span aria-hidden="true">→</span></a>' +
          '<button type="button" class="ulm__cont" data-ulm-close>' + esc(T.cont) + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.closest('[data-ulm-close]')) { close(); return; }
      var nudge = t.closest('[data-ulm-nudge]');
      if (nudge) { addNudge(nudge); return; }
      var btn = t.closest('[data-ulm-qty]');
      if (btn) {
        var row = btn.closest('[data-ulm-line]');
        var qty = parseInt(row.getAttribute('data-ulm-qty-now'), 10) + parseInt(btn.getAttribute('data-ulm-qty'), 10);
        change(row.getAttribute('data-ulm-line'), Math.max(0, qty), row);
        return;
      }
      var rm = t.closest('[data-ulm-remove]');
      if (rm) {
        var r = rm.closest('[data-ulm-line]');
        change(r.getAttribute('data-ulm-line'), 0, r);
      }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && modal && !modal.hidden) close();
    });
    return modal;
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('ulm-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    load();
    setTimeout(function () { var c = modal.querySelector('.ulm__card'); if (c) c.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('ulm-open');
    setTimeout(function () { modal.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---- data ---- */
  function load() {
    modal.classList.add('is-loading');
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { modal.classList.remove('is-loading'); });
  }

  function change(line, quantity, row) {
    if (busy) return;
    busy = true;
    if (row) row.classList.add('is-busy');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncBubble(); })
      .catch(function () { load(); })
      .then(function () { busy = false; });
  }

  function addNudge(btn) {
    if (busy) return;
    busy = true;
    btn.disabled = true;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: NUDGE_VARIANT, quantity: 1 }] })
    })
      .then(function () { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncBubble(); })
      .catch(function () { load(); })
      .then(function () { busy = false; btn.disabled = false; });
  }

  function syncBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch(ROOT + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (!s || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---- render ---- */
  function render(cart) {
    build();
    modal.classList.remove('is-loading');
    var items = cart.items || [];
    var total = cart.total_price || 0;
    var count = cart.item_count || 0;

    modal.classList.toggle('is-empty', items.length === 0);
    modal.querySelector('.ulm__count').textContent = count ? T.items(count) : '';

    /* shipping bar */
    var pct = Math.max(0, Math.min(100, Math.round(total / THRESHOLD * 100)));
    var ship = modal.querySelector('.ulm__ship');
    var nudge = modal.querySelector('.ulm__nudge');
    ship.classList.toggle('is-done', total >= THRESHOLD);
    modal.querySelector('.ulm__ship-text').innerHTML = total >= THRESHOLD ? T.freeDone : T.freeLeft(money(THRESHOLD - total));
    modal.querySelector('.ulm__bar i').style.width = pct + '%';
    modal.querySelector('.ulm__bar').setAttribute('aria-valuenow', String(pct));
    var showNudge = !!(items.length && total < THRESHOLD && (THRESHOLD - total) <= 3000);
    nudge.hidden = !showNudge;
    nudge.style.display = showNudge ? '' : 'none';

    /* lines */
    var html = '';
    if (!items.length) {
      html = '<div class="ulm__empty"><div class="ulm__empty-art" aria-hidden="true">🧺</div><p class="ulm__empty-title">' + esc(T.empty) + '</p><p class="ulm__empty-sub">' + esc(T.emptySub) + '</p><a class="ulm__shop" href="' + ROOT + 'collections/shop">' + esc(T.shop) + '</a></div>';
    } else {
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        html +=
          '<div class="ulm__line" data-ulm-line="' + esc(it.key) + '" data-ulm-qty-now="' + it.quantity + '">' +
            '<span class="ulm__check" aria-hidden="true">✓</span>' +
            '<a class="ulm__thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a>' +
            '<div class="ulm__info">' +
              '<a class="ulm__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
              (variant ? '<span class="ulm__variant">' + esc(variant) + '</span>' : '') +
              '<div class="ulm__row">' +
                '<span class="ulm__qty"><button type="button" data-ulm-qty="-1" aria-label="−">−</button><b>' + it.quantity + '</b><button type="button" data-ulm-qty="1" aria-label="+">+</button></span>' +
                '<b class="ulm__price">' + money(it.original_line_price) + '</b>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="ulm__remove" data-ulm-remove aria-label="' + esc(T.remove) + '" title="' + esc(T.remove) + '">×</button>' +
          '</div>';
      }
    }
    modal.querySelector('.ulm__list').innerHTML = html;
    modal.querySelector('.ulm__total').textContent = money(total);
    var disc = cart.total_discount || 0;
    modal.querySelector('.ulm__disc').style.display = disc ? '' : 'none';
    modal.querySelector('.ulm__disc-val').textContent = '−' + money(disc);
  }

  /* ---- route Dawn's drawer here ---- */
  function hook() {
    var CD = window.customElements && customElements.get('cart-drawer');
    if (!CD || !CD.prototype || CD.prototype.__ulm) return;
    CD.prototype.__ulm = true;
    CD.prototype.open = function () { open(); };
    CD.prototype.close = function () { close(); };
    CD.prototype.renderContents = function () { open(); };
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(hook).catch(function () {});
  }
  hook();

  /* Header bag icon: works even if the cart-drawer element is missing. */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('#cart-icon-bubble');
    if (!a) return;
    ev.preventDefault();
    open();
  }, true);

  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted && modal && !modal.hidden) load();
  });
})();
